<template>
    <div class="vue-root">

    </div>
</template>

<script>
    const componentName = 'root-layout';
    export default {
        name: componentName,
        methods: {
            // TODO: remove when vue layout manager is active.
        },
    }
</script>

<style scoped>

</style>
